// subscribeFeedChannel.js
'use strict';
import * as MessageTypes from '../serviceWorker/AppMessageTypes.js';
import { sendMessageToSW } from '../serviceWorker/helpers.js';

/**
 * Subscribe feed channel
 * @kind action
 * @param {string} {feedName} - feed name.
 * @return {Promise} Action promise.
 */
const subscribeFeedChannel =
  ({ feedName }) =>
  async dispatch => {
    if (!feedName) {
      return dispatch({ type: '' });
    }
    return sendMessageToSW({
      type: MessageTypes.SUBSCRIBE_FEED_CHANNEL,
      payload: {
        feedName,
      },
    });
  };

export default subscribeFeedChannel;
